import scribdAuthorize from '../scribd/scribd_oauth.js';

(function(win) {

  var $ = win.$,
      ss = win.slideshare_object,
      utils = ss.utils,
      ClipboardModalShare = utils.imports('ClipboardModalShare'),
      TopClipboardsModal = utils.imports('clips.TopClipboardsModal'),
      SelectClipboardModal = utils.imports('SelectClipboardModal'),
      Tracker = utils.imports('clips.Tracker'),
      // Success toast for new clipping flow
      SuccessToast = utils.imports('clips.SuccessToast'),
      eventManager = $.slideshareEventManager,
      hasFoundation = !!$.fn.foundation,
      localStorage = win.localStorage,
      clipsToolbarProto,
      i18n = slideshare_object.utils.i18n,
      i18n_locale = slideshare_object.utils.i18n_locale(),
      xmessage = window.xmessage,
      storageKeys = {
        clippedOnce: 'slideshare.clips.clippedOnce.' + ss.user.id,
        defaultClipboard: 'slideshare.clips.defaultClipboard.' + ss.user.id
      },
      events = {
        clipCreated: 'clip:created',
        clipDeleted: 'clip:deleted',
        clipMoved: 'clip:moved',
        clipboardCreated: 'clipboard:created'
      },
      selectors = {
        clipButton: '.j-clips-button',
        clipsToolbar: '.j-clips-toolbar',
        clipsToolbarActive: '.j-clips-toolbar:not(.inactive,.unavailable)',
        clipboardCreateModal: '#clipboard-create-modal',
        selectClipboardModal: '#select-clipboard-modal'
      },
      SYSTEM_CLIPBOARD_TITLE = "My Clips";

  function ClipsToolbar() {
    if (!$.slideshareEventManager) {
      return;
    }

    this.api = utils.imports('clips.api');
    ss.Clipboards.api = this.api;
    this.tracker = new Tracker();
    this.topClipboardsModal = new TopClipboardsModal({ el: '#top-clipboards-modal' });
    this.successToast = new SuccessToast();
    this.ariaLabel = "aria-label";

    this.$clipsToolbar = $(selectors.clipsToolbar);
    this.$clipsInfo = $('.j-clips-info');
    this.$clipsCount = $('.j-clips-count');
    this.$slidePosition = $('.j-slide-position');
    this.$progressMeter = $('.j-clips-meter');
    this.$clipButtonTop = $('.clip-button-top');
    this.$clipRibbonContent = this.$clipButtonTop.find('.ribbon-content');
    this.$clipButtonAnchor = this.$clipButtonTop.find('#clips-button-top');
    this.$clipButton = $(selectors.clipButton);
    this.$clipButton.show();
    this.afterLoginRedirectLink = this.$clipButton.attr('href');

    this.clips = ss.slideshow.clips || {};
    this.clipCounts = ss.slideshow.clip_counts || {};
    this.userClipsNumber = ss.user.clips_number || 0;
    this.clipboards = ss.user.clipboards || [];

    this.toggleClipButton(false);
    this.bindEvents();
    this.updateSlideState();

    // If this experience is rendered after an unauthenticated user clipped and then
    // logged in, display the toast.
    if (ss.after_login_clip_data) {
      this.tracker.trackAfterLogin();
      this._forceToastAfterLogin();
    }
  }

  // Cache the prototype.
  clipsToolbarProto = ClipsToolbar.prototype;

  clipsToolbarProto.activate = function() {};

  clipsToolbarProto.handleClipActionLoggedout = function(e) {
    e.preventDefault();
    e.stopPropagation();
    var trackingId = this.tracker.trackingId();
    var gaLabel = "create_loggedout";

    ss.ga('clips', 'click', gaLabel);
    ss.addAfterLoginEvent({
      event: 'clip',
      data: {
        slideshow_id: ss.slideshow.id,
        position: $.slideshareEventManager.getCurrentPosition(),
        tracking_id: trackingId
      }
    });
    scribdAuthorize({ from_source: ss.slideshow.ss_url + '/' + $.slideshareEventManager.getCurrentPosition(), slideshow_id: ss.slideshow.id });
  };

  clipsToolbarProto.bindEvents = function() {
    // Clip button
    this.$clipButton.off('click').on('click', function(e) {
      if (utils.isUserAuthenticated() && ss.slideshow.allow_clips) {
        this.clipSlide(eventManager.getCurrentPosition());
        return;
      }
      
      this.handleClipActionLoggedout(e);    
    }.bind(this));

    // Previous/next slide
    if (eventManager.player) {
      eventManager.player.on('slidechanged.toolbarClips', function() {
        this.updateSlideState();
      }.bind(this));

      var clipCtaSlideChangeEvents = 'next.clipcta previous.clipcta gotoslide.clipcta';
      eventManager.player.on(clipCtaSlideChangeEvents, function(data) {
        // Clip CTA: hide button on initial slide change
        // Can't listen on slidechanged event because it is called
        // when slideview loads on a non-first slide
        // Don't hide button when slide change is from player band click
        eventManager.player.off(clipCtaSlideChangeEvents);
        if (data.ssData && data.ssData.source === 'band') {
          return;
        }
        this.$clipButton.removeClass('visible');
      }.bind(this));
    }

    $(document).on('click', selectors.clipsToolbarActive, this._onClipsToolbarClick.bind(this));
  };

  clipsToolbarProto._onClipsToolbarClick = function(e) {
    this.topClipboardsModal.open(
      ss.slideshow.id,
      eventManager.getCurrentPosition());
  };

  clipsToolbarProto.updateSlideState = function() {    
    const position = $.slideshareEventManager.getCurrentPosition();
    const currentClip = this.clips[position];
    const clipsCount = parseInt(this.clipCounts[position], 10);

    let alreadyInUsersClipboard = false;
    
    //reset clip values in html
    this.$clipButtonTop.removeClass('clipped');
    this.$clipRibbonContent.removeClass('with-clip-count');
    this.$clipsCount.removeClass('decrease-clip-count-text-size');
    this.$clipsCount.text('');
    this.$clipsCount.attr('');
    this.$clipsInfo.toggleClass('j-clips-info-none', !this.clipCounts[position]);
    this.$clipsToolbar.toggleClass('inactive', !this.clipCounts[position]);

    if (currentClip) {
      alreadyInUsersClipboard = this.clipboards.find((elem) => elem.user_id === currentClip.user_id);
    }

    if (!!alreadyInUsersClipboard) {
      this.$clipButtonTop.addClass('clipped');
    }

    this.setClippedClassAndAnchorTitle(!!alreadyInUsersClipboard, clipsCount);
    this.$slidePosition.attr(this.ariaLabel, position);
    this.updateProgress(this.clips[position] ? 100 : 0, false);
  };

  clipsToolbarProto.setClippedClassAndAnchorTitle = function (alreadyInUsersClipboard, clipsCount) {
    let clipButtonAnchorTitle = '';

    if (!clipsCount) {
      // slide was not clipped by any user - show the plus icon in the clip ribbon
      clipButtonAnchorTitle = slideshare_object.utils.i18n('slideshow.clip_cta.clip_slide_title_first_person');
    } else if (clipsCount === 1) {
      if (alreadyInUsersClipboard) {
        // number of clips is 1 & clipped by the current user - show check icon in the clip ribbon
        clipButtonAnchorTitle = slideshare_object.utils.i18n('slideshow.clip_cta.clip_slide_title_first_slide_clipped');
      } else {
        clipButtonAnchorTitle = slideshare_object.utils.i18n('slideshow.clip_cta.clip_slide_title_multiple_people', { count: +clipsCount });
        this.$clipRibbonContent.addClass('with-clip-count');
        this.setClipsCountAndFontSize(this.formatClipsCount(clipsCount));
        this.$clipsCount.attr(this.ariaLabel, clipsCount);
      }
    } else if (clipsCount > 1) {
      if (alreadyInUsersClipboard) {
       // User clipped slide - show check icon & count in the clip ribbon
         clipButtonAnchorTitle = slideshare_object.utils.i18n('slideshow.clip_cta.clip_slide_title_you_and_more_people', { count: +clipsCount - 1 });
       } else {
       // User has not clipped the slide - show plus icon & count in the clip ribbon
         clipButtonAnchorTitle = slideshare_object.utils.i18n('slideshow.clip_cta.clip_slide_title_multiple_people', { count: +clipsCount });
       }
       this.$clipRibbonContent.addClass('with-clip-count');
       this.setClipsCountAndFontSize(this.formatClipsCount(clipsCount));
       this.$clipsCount.attr(this.ariaLabel, clipsCount);
     } 
    this.$clipButtonAnchor.attr("title", clipButtonAnchorTitle);
  };

  clipsToolbarProto.formatClipsCount = function (clipsCount) {
    if (clipsCount >= 1e3 && clipsCount < 1e6) {
      return this.roundClipsCount(clipsCount, 1e3, "K");
    } else if (clipsCount >= 1e6 && clipsCount < 1e9) {
      return this.roundClipsCount(clipsCount, 1e6, "M");
    } else if (clipsCount >= 1e9 && clipsCount < 1e12) {
      return this.roundClipsCount(clipsCount, 1e9, "B");
    } else {
      return clipsCount;
    }
  };

  clipsToolbarProto.roundClipsCount = function (clipsCount, divisor, postFix) {
    const formattedClipsCount = +(clipsCount / divisor).toFixed(1) + postFix;
    // Clip ribbon fits maximum four characters, rounding off when more than 4 characters in length
    if (formattedClipsCount.toString().length > 4) {
      return Math.floor((clipsCount / divisor)) + postFix;
    } else {
      return +(clipsCount / divisor).toFixed(1) + postFix;
    }
  }

  clipsToolbarProto.setClipsCountAndFontSize = function (clipsCount) {
    // when the clips count has 4 characters, make font-size 12px
    if (clipsCount.toString().length >= 4) {
      this.$clipsCount.addClass('decrease-clip-count-text-size');
    }
    this.$clipsCount.text(clipsCount);
  };

  clipsToolbarProto.updateProgress = function(progress, animate) {
    this.$progressMeter.toggleClass('j-animate', animate).css('width', progress + '%');
  };

  clipsToolbarProto.toggleClipButton = function(pending) {
    this.$clipButton.toggleClass('pending', pending).prop('disabled', pending);
  };

  clipsToolbarProto.setClipData = function(clip) {
    this.clips[clip.position] = clip;
    this.clipCounts[clip.position] = (this.clipCounts[clip.position] || 0) + 1;
    this.userClipsNumber++;
  };

  clipsToolbarProto.hasUserClippedOnce = function() {
    return this.userClipsNumber || !localStorage || localStorage.getItem(storageKeys.clippedOnce);
  };

  clipsToolbarProto.setUserClippedOnce = function() {
    if (localStorage) {
      localStorage.setItem(storageKeys.clippedOnce, true);
    }
  };

  clipsToolbarProto._currentClip = function() {
    return this.clips[eventManager.getCurrentPosition()];
  };

  clipsToolbarProto._getClipboard = function(clipboardId) {
    var filtered_clipboards = this.clipboards.filter(function(cb){
      return cb.id == clipboardId;
    });
    if(filtered_clipboards.length){
      return filtered_clipboards[0];
    }
  };

  clipsToolbarProto.clipSlide = function(position) {
    function createClip(position) {
      this.createClip(position)
        .always(function() {
          this.updateSlideState();
          this.toggleClipButton(false);
        }.bind(this));
      this.toggleClipButton(true);
    }

    var clip = this.clips[position];

    if (!clip && !this.hasUserClippedOnce()) {
      // First time clipper
      // Display a modal asking user for a clipboard title/description
      // Create a clip & clipboard even if the user cancels the modal
      this.setUserClippedOnce();
      var createModal = new ss.Clipboards.EditModal({
        el: selectors.clipboardCreateModal,
        type: 'create',
        showFirstClipMessage: true,
        onClose: function(status, response) {
          createClip.call(this, position);
        }.bind(this)
      });
      createModal.open();
    } else {
      // Create the clip
      createClip.call(this, position);
    }

    //GA tracking for clip click
    ss.ga('clips', 'click', 'create');
  };

  clipsToolbarProto.onError = function(message) {
    var logError = window.console &&
          (console.error || console.log).bind(console) || function() {};
    logError(message);
  };

  clipsToolbarProto.createClip = function(position) {

    var allClipboards = [];
    var clip = {
      slideshow_id: ss.slideshow.id,
      user_id: ss.user.id,
      position: position
    };

    this.updateProgress(90, true);

    // 1. Get Clipboards. We assume they are alpha sorted already
    return this.getClipboards()

    // 2. Create the clipboard if it's a fake one (= without id)
      .then(function(clipboards) {
        var defaultClipboard = this.getDefaultClipboard(clipboards);
        allClipboards = clipboards;
        return (defaultClipboard && defaultClipboard.id) ? defaultClipboard : this.createClipboard(defaultClipboard);
      }.bind(this))

    // 3. Add clip to the clipboard
      .then(function(clipboard) {
        return this.addClipToClipboard(clip, clipboard);
      }.bind(this))

    // 4. Update UI
      .then(function(data) {
        if (data.clip.alreadyInClipboard) {
          // Conflict error, clip already exists in clipboard
          // Show the select clipboard modal
          var clip = this.clips[eventManager.getCurrentPosition()],
              selectModal = new SelectClipboardModal({
                el: selectors.selectClipboardModal,
                defaultClipboard: data.clipboard,
                actionType: 'copy'
              });
          selectModal.open({clip: data.clip});
        } else {
          if (!this.clips[data.clip.position]) {
            //only update clip data if this is a newly created clip
            this.setClipData(data.clip);
          }

          this.updateSlideState();
          $(document).trigger(events.clipCreated, data);
        }
      }.bind(this))

    // Error handling
      .fail(function(xhr, status, error) {
        if (xhr) {
          this.onError(slideshare_object.utils.i18n('clip.clips.error_clipping') + " " + xhr.statusText);
        }
      }.bind(this));
  };

  clipsToolbarProto.createFakeSystemClipboard = function() {
    return {
      title: SYSTEM_CLIPBOARD_TITLE,
      'private': false,
      system_created: true,
      is_default: true
    };
  };

  clipsToolbarProto.getClipboards = function() {
    return this.api.clipboards()
      .fail(function(xhr, status, error) {
        this.onError(slideshare_object.utils.i18n('clip.clips.error_fetching_clipboards') + " " + xhr.statusText);
      }.bind(this))
      .done(function(data) {
        var clipboards = data || [];

        // If no Clipboard exist for the current user,
        // Add a fake one (= without id). This Clipboard will eventually be
        // created later (when user will actually clip)
        if (clipboards.length === 0) {
          clipboards.push(this.createFakeSystemClipboard());
        } else {
          // Find the default clipboard and add a `is_default` property to the
          // default clipboard:
          // 1. Use the one stored in local storage
          // 2. Or, use the first system-generated clipboard in alpha order
          // 3. Or, use the first clipboard in alpha order
          // Note: we assume the backend
          // TODO: this should be done by the back-end at some point
          var defaultClipboard = null,
              defaultClipboardId = this.getUserDefaultClipboardId();

          clipboards.some(function(clipboard) {
            if (defaultClipboardId && defaultClipboardId === clipboard.id ||
                !defaultClipboard ||
                !defaultClipboard.system_created && clipboard.system_created
               ) {
                 defaultClipboard = clipboard;

                 // Stop iterating by returning `true` (cf `Array.prototype.some`),
                 // if it's the user's default clipboard
                 return defaultClipboardId && clipboard.id === defaultClipboardId;
               }
          });
          defaultClipboard.is_default = true;
          this.setUserDefaultClipboard(defaultClipboard.id);
        }

        return clipboards;
      }.bind(this));
  };

  clipsToolbarProto.getUserDefaultClipboardId = function() {
    return Number(localStorage && localStorage.getItem(storageKeys.defaultClipboard)) || false;
  };

  clipsToolbarProto.setUserDefaultClipboard = function(clipboardId) {
    if (localStorage) {
      localStorage.setItem(storageKeys.defaultClipboard, clipboardId);
    }
  };

  /**
   * Creates a new clipboard
   * @public
   * @param {object} clipboard The clipboard to create
   * @returns {jqXHR} the jqXHR object associated with the request
   */
  clipsToolbarProto.createClipboard = function(clipboard) {
    return this.api.createClipboard(clipboard)
      .then(function(data) {
        this.clipboards.push(data.clipboard);
        $(document).trigger(events.clipboardCreated, data);
        return data.clipboard;
      }.bind(this), function(xhr) {
        this.onError(slideshare_object.utils.i18n('clip.clips.error_creating_clipboard') + " " + xhr.statusText);
      }.bind(this));
  };

  /**
   * Adds a new clip to a given clipboard
   * @public
   * @param {object} clip The clip being added
   * @param {object} toClipboard The clipboard to add clip to
   * @returns {jqXHR} The jqXHR object associated with the request
   */
  clipsToolbarProto.addClipToClipboard = function(clip, clipboard) {

    // update the list of clipboards associated with the clip
    function updateClip(data){
      var clip = this.clips[eventManager.getCurrentPosition()];
      if(clip){
        clip.clipboards = clip.clipboards || [];
        if (clip.clipboards.indexOf(clipboard.id) === -1) {
          clip.clipboards.push(clipboard.id);
        }
      } else {
        data.clip.clipboards = [clipboard.id];
      }
    }

    return this.api.addClipToClipboard(clipboard.id, clip)
      .then(function(data) {
        updateClip.call(this, data);
        return {
          clip: data.clip,
          clipboard: clipboard
        };
      }.bind(this), function(xhr, status, error) {
        this.onError(slideshare_object.utils.i18n('clip.clips.error_adding_to_clipboard') + " " + xhr.statusText);
      }.bind(this));

  };

  clipsToolbarProto.getDefaultClipboard = function(clipboards) {
    var i;
    for (i = 0; i < clipboards.length; i++) {
      if (clipboards[i].is_default) {
        return clipboards[i];
      }
    }
    return null;
  };

  /**
   * Renders the toast after fetching the user's clipboards and populating
   * the toast's dropdown. This method is invoked when an unauthenticated user
   * clips and the logs in
   * @private
   */
  clipsToolbarProto._forceToastAfterLogin = function() {
    var data = ss.after_login_clip_data;
    this.successToast.show({}, {
      clip: data.clip,
      clipboard: data.clipboard
    });
  };

  // Export this module.
  utils.exports('clips.Toolbar', ClipsToolbar);

}(window));
